import { Box, CircularProgress, Typography } from "@mui/material";

const LoadingOverlay = ({ fixed = false, contained = false, text = "Loading..." }) => {
    if (contained) {
        return (
            <Box
                sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    bgcolor: "rgba(255,255,255,0.9)",
                    zIndex: 100,
                }}
            >
                <Box
                    sx={{
                        position: "sticky",
                        top: "50%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: 2,
                        py: 4,
                    }}
                >
                    <CircularProgress size={48} />
                    {text && (
                        <Typography sx={{ color: "#374151", fontSize: "1rem" }}>{text}</Typography>
                    )}
                </Box>
            </Box>
        );
    }

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                bgcolor: "#ffffff",
                gap: 2,
                ...(fixed
                    ? {
                          position: "fixed",
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          zIndex: 9999,
                      }
                    : {
                          height: "100vh",
                      }),
            }}
        >
            <CircularProgress size={48} />
            {text && <Typography sx={{ color: "#374151", fontSize: "1rem" }}>{text}</Typography>}
        </Box>
    );
};

export default LoadingOverlay;
